
<div class="modal-header">
    <h2 class="modal-title">{{ (emailId? 'email.editEmail' : 'email.addAndConfigureEmail') | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>
<form #addEmail="ngForm" class="add-email-form-container">

<div class="modal-body">
    <div *ngIf="hasRequestTypeNotAssociated" class="alert alert-info custom-alert" role="alert">
        <div class="alert-body d-flex align-items-center">
            <i class="app-icon icon icon-info-circle-fill text-info icon-xl me-4"></i>
            <span class="alert-text custom-alert-text" [innerHTML]="'email.alertRequestTypesAreNotAssociatedOnEmail' | translate">
            </span>
        </div>
    </div>

    <div class="col-lg-6" *ngIf="!enableEmailConfigurationForAdminsOnly">
        <label class="label-input">{{'email.email' | translate}}<span class="text-primary fw-bold"> *</span></label>
        <input HJSuppress
            class="text-input"
            type="text"
            kendoTextBox
            rounded="none"
            name="email"
            #email="ngModel"
            [(ngModel)]="emailXRequestTypes.emailAddress"
            [pattern]="emailValidator"
            [placeholder]="'email.emailPlaceholder' | translate"
            required>
        <div class="error-info" *ngIf="email.invalid  && (email.dirty || addEmail.submitted)">
            <div  *ngIf="email.errors?.['required']" >
                {{'common.validation.required' | translate}}
            </div>
            <div  *ngIf="email.errors?.['pattern']">
                {{'common.validation.emailInvalid' | translate}}
            </div>
        </div>
    </div>

    <div *ngIf="enableEmailConfigurationForAdminsOnly">
        <div class="col-lg-6">
            <kendo-dropdownlist HJSuppress
                    #email="ngModel"
                    [fillMode]="fillModeOutline"
                    [rounded]="roundedLarge"
                    [size]="sizeLarge"
                    [data]="adminUsers"
                    textField="email"
                    valueField="email"
                    [valuePrimitive]="true"
                    name="email"
                    [(ngModel)]="emailXRequestTypes.emailAddress"
                    [popupSettings]="{popupClass : 'data-hj-suppress', appendTo : 'component'}"
                    required
                >
            </kendo-dropdownlist>
        </div>
        <div class="error-info" *ngIf="email.invalid  && (email.dirty || addEmail.submitted)">
            <div  *ngIf="email.errors?.['required']" >
                {{'common.validation.required' | translate}}
            </div>
            <div  *ngIf="email.errors?.['pattern']">
                {{'common.validation.emailInvalid' | translate}}
            </div>
        </div>
    </div>
    <div class="l-separator"></div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input
                class="checkbox-input"
                type="checkbox"
                id="allAssetDocumentRequestTypes"
                name="allAssetDocumentRequestTypes"
                [rounded]="rounded"
                [size]="size"
                kendoCheckBox
                [(ngModel)]="allAssetDocumentRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryAssetDocumentRequestTypes, assetDocumentRequestTypeCheckboxStates, emailXRequestTypes.dictionaryAssetDocumentRequestTypeIds)"
            >
            <label for="allAssetDocumentRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.assetDocuments' | translate}}</label>
        </div>

        <div class="request-types-container">

            <div *ngFor="let requestType of dictionaryAssetDocumentRequestTypes">
                <input
                    class="checkbox-input"
                    type="checkbox"
                    [id]="'ad-'+requestType.code"
                    [name]="'ad-'+requestType.code"
                    [rounded]="rounded"
                    [size]="size"
                    kendoCheckBox
                    [(ngModel)]="assetDocumentRequestTypeCheckboxStates[requestType.id]"
                    (change)="allAssetDocumentRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryAssetDocumentRequestTypes, assetDocumentRequestTypeCheckboxStates, emailXRequestTypes.dictionaryAssetDocumentRequestTypeIds)"
                >
                <label [for]="'ad-'+requestType.code" class="ms-2 cursor-pointer"
                    [class.fw-bold]="!requestType.isAssociatedToEmail">
                    {{ requestType.value }}
                </label>
            </div>

        </div>
    </div>

    <div class="l-separator"></div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input
                class="checkbox-input"
                type="checkbox"
                id="allContractModificationRequestTypes"
                name="allContractModificationRequestTypes"
                [rounded]="rounded"
                [size]="size"
                kendoCheckBox
                [(ngModel)]="allContractModificationRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryContractModificationRequestTypes, contractModificationRequestTypeCheckboxStates, emailXRequestTypes.dictionaryContractModificationRequestTypeIds)"
            >
            <label for="allContractModificationRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.contractModification' | translate}}</label>
        </div>

        <div class="request-types-container">

            <div *ngFor="let requestType of dictionaryContractModificationRequestTypes">
                <input
                    class="checkbox-input"
                    type="checkbox"
                    [id]="'cm-'+requestType.code"
                    [name]="'cm-'+requestType.code"
                    [rounded]="rounded"
                    [size]="size"
                    kendoCheckBox
                    [(ngModel)]="contractModificationRequestTypeCheckboxStates[requestType.id]"
                    (change)="allContractModificationRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryContractModificationRequestTypes, contractModificationRequestTypeCheckboxStates, emailXRequestTypes.dictionaryContractModificationRequestTypeIds)"
                >
                <label [for]="'cm-'+requestType.code" class="ms-2 cursor-pointer"
                    [class.fw-bold]="!requestType.isAssociatedToEmail">
                    {{ requestType.value }}
                </label>
            </div>

        </div>
    </div>

    <div class="l-separator"></div>

    <div>
        <div class="d-flex align-items-center mb-3 pb-1">
            <input
                class="checkbox-input"
                type="checkbox"
                id="allClientDataRequestTypes"
                name="allClientDataRequestTypes"
                [rounded]="rounded"
                [size]="size"
                kendoCheckBox
                [(ngModel)]="allClientDataRequestTypes"
                (ngModelChange)="onAllRequestTypeCheckboxChange($event, dictionaryClientDataRequestTypes, clientDataRequestTypeCheckboxStates, emailXRequestTypes.dictionaryClientDataRequestTypeIds)"
            >
            <label for="allClientDataRequestTypes" class="ms-2 request-type-title cursor-pointer">{{'email.myData' | translate}}</label>
        </div>

        <div class="request-types-container">

            <div *ngFor="let requestType of dictionaryClientDataRequestTypes">
                <input
                    class="checkbox-input"
                    type="checkbox"
                    [id]="'cd-'+requestType.code"
                    [name]="'cd-'+requestType.code"
                    [rounded]="rounded"
                    [size]="size"
                    kendoCheckBox
                    [(ngModel)]="clientDataRequestTypeCheckboxStates[requestType.id]"
                    (change)="allClientDataRequestTypes = onRequestTypeCheckboxChange(requestType.id, dictionaryClientDataRequestTypes, clientDataRequestTypeCheckboxStates, emailXRequestTypes.dictionaryClientDataRequestTypeIds)"
                >
                <label [for]="'cd-'+requestType.code" class="ms-2 cursor-pointer"
                    [class.fw-bold]="!requestType.isAssociatedToEmail">
                    {{ requestType.value }}
                </label>
            </div>

        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="closeHandler()">
        <i class="app-icon icon icon-return icon-lg me-2"></i>
        {{'common.cancel' | translate}}
    </button>
    <button class="btn primary-btn" (click)="saveHandler()">
        {{( emailId ? 'common.save' : 'email.addEmail') | translate}}
    </button>
</div>

</form>
